<template>
  <div class="contact">
    <div class="contentInfo">
      <div class="contact">
        <div class="rfqtitle">Holden Quotation for "{{projectname}}"</div>
        <!-- <div class="button" style=""> <button @click="dialogVisible=true;sendQuotationEMail()">Send me the quotation by email</button> </div> -->
        <div style="margin-top:10px;">Below is our ballpark cost for your project. </br> Please note this is not the final cost. It's based on the basic information you provided here and would change if any criteria changes.</div>
        <!-- <div class="holden"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/logo.png" alt=""></div>
        <div class="introduce"> …..your Asian team on the ground</div> -->
        <!-- <div v-if="qualtableData.length<0" class="wrong">The quotation is wrong, please click "More Request" to quote again</div> -->
        <div class="quant rfq" v-if="quanttableData.length>0">
          <div class="label">Quantitative</div>
          <el-table ref="quant" max-height="500" :data="quanttableData" border highlight-current-row style="width: 100%" :header-cell-style="{background:'#ecf5ff'}" :row-class-name="tableRowClassName">
            <el-table-column prop="marketName" label="Market" align="center" width="280">
            </el-table-column>
            <el-table-column prop="targetName" label="Target" align="center">
            </el-table-column>
            <el-table-column prop="irLeverName" label="IR" align="center" width="80">
            </el-table-column>
            <el-table-column prop="loiName" label="LOI" align="center" width="100">
            </el-table-column>
            <el-table-column prop="number" label="N" width="50" align="center">
            </el-table-column>
            <el-table-column prop="cpiRecruitment" label="CPI-recruitment (USD)" align="center" width="110">
            </el-table-column>
            <el-table-column prop="cpiIncentive" label="CPI-incentive (USD)" align="center" width="100">
            </el-table-column>
            <el-table-column prop="cpiTotal" label="CPI-total (USD)" align="center" width="70">
            </el-table-column>
            <el-table-column prop="subTotal" label="Sub-Total (USD)" align="center" width="90">
            </el-table-column>
            <!-- <el-table-column prop="discount" label="Discount" align="center" width="90" v-if="discount">
            </el-table-column> -->
            <!-- <el-table-column prop="specialDiscount" label="Special Discount" align="center" width="" v-if="specialDiscountShow">
            </el-table-column> -->
            <!-- <el-table-column prop="subTotalDiscount" label="Sub-Total after discount (USD)" align="center" width="100" v-if="discount">
            </el-table-column> -->
            <!-- <el-table-column prop="Timeline" label="Timeline" width="120" align="center">
            </el-table-column> -->
          </el-table>
          <el-tooltip placement="right-start">
            <div slot="content">* The minimum project fee is: $500 for each market.
              <br />* The CPI will change if the sample size change.
              <br />* Timeline is counted from full launch. Usually we need 1-3 days for set up.
              <br />* Price and feasibility are based on the information available at the time of quotation.
              <br />* Price and feasibility can change if the specs of the project change.
              <br />* Estimate conditions will be valid for 60 days. After 60 days price and feasibility can change.
              <br />* All prices are in USD.
            </div>
            <span style="color:red;cursor:pointer">*Terms & conditions</span>

          </el-tooltip>
        </div>

        <div class="qual rfq" v-if="qualtableData.length>0">
          <div class="label">Qualitative</div>

          <!-- <el-table style="width: 100%" :data="qualtableData.rows" border highlight-current-row :header-cell-style="{background:'#ecf5ff'}" :cell-class-name="addClass" :row-class-name="tableRowClassName"> -->

          <!-- <el-table-column align="center" v-for="(each, ind) in qualtableData.secondaryHeader['key']" width="120">
                    <div>{{each.content}}</div>

         
              </el-table-column> -->

          <!-- <template v-for="(item, index) in qualtableData.headers">
              <el-table-column align="center" :label="item.market" :key="`${index}`">
                <el-table-column align="center" v-for="(each, ind) in qualtableData.secondaryHeader[`${item.key_str}`]" :width="width">
                  <template slot="header">
                    <div>{{ each.name }}</div>
                  </template>
                  <template slot-scope="{ row }">
                    <div>{{ row[`${item.key_str}`][each.content] }}</div>
                  </template>
                </el-table-column>
              </el-table-column>
            </template>
          </el-table> -->
          <div v-for="item in qualtableData">
            <el-table ref="quant" max-height="500" :data="item.list" border highlight-current-row style="width: 100%" :header-cell-style="{background:'#ecf5ff'}" :span-method="arraySpanMethod" :row-class-name="tableRowClassName">
              <el-table-column prop="rowName" :label="item.marketName" align="center">
              </el-table-column>
              <el-table-column prop="cpi" label="CPI(USD)" align="center">
              </el-table-column>
              <el-table-column prop="unit" label="Unit" align="center">
              </el-table-column>
              <el-table-column prop="subTotal" label="SubTotal(USD)" align="center">
              </el-table-column>

            </el-table>
          </div>
          <el-tooltip placement="right-start">
            <div slot="content">
              * If an booked interview is cancelled by client, cancel fee is: 100% of recruitment fee + 50% of incentive.
              <br />* If an approved respondent (interview time hasn't been booked) is cancelled by client, cancel fee is: 100% of recruitment fee.
              <br />* If an booked interview is required to re-schedule by client within 48 hours before the interview, re-schedule fee is: $30 each.
              <br />* Price and feasibility are based on the information available at the time of quotation.
              <br />* Price and feasibility can change if the specs of the project change.
              <br />* Estimate conditions will be valid for 60 days. After 60 days price and feasibility can change.
              <br />* All prices are in USD.
            </div>
            <span style="color:red;cursor:pointer">*Terms & conditions</span>

          </el-tooltip>
          <div>Price is based on the service what we delivery.</div>

        </div>

        <!-- <div class="attention" v-if="quanttableData.length>0||Object.keys(qualtableData).length>0">
          <div style="color:red">Terms & conditions</div>
          <div class="quantAttention" v-if="quanttableData.length>0">
            <div>Quantitative</div>
            <div>* The minimum project fee is: $500 for each market.</div>
            <div>* The CPI will change if the sample size change.</div>
            <div>* Timeline is counted from full launch. Usually we need 1-3 days for set up.</div>
            <div>* Price and feasibility are based on the information available at the time of quotation.</div>
            <div>* Price and feasibility can change if the specs of the project change.</div>
            <div>* Estimate conditions will be valid for 60 days. After 60 days price and feasibility can change.</div>
            <div>* All prices are in USD.</div>

          </div>
          <div class="qualAttention" v-if="Object.keys(qualtableData).length>0">
            <div>Qualitative</div>
            <div>* If an booked interview is cancelled by client, cancel fee is: 100% of recruitment fee + 50% of incentive.</div>
            <div>* If an approved respondent (interview time hasn't been booked) is cancelled by client, cancel fee is: 100% of recruitment fee.</div>
            <div>* If an booked interview is required to re-schedule by client within 48 hours before the interview, re-schedule fee is: $30 each.</div>
            <div>* Price and feasibility are based on the information available at the time of quotation.</div>
            <div>* Price and feasibility can change if the specs of the project change.</div>
            <div>* Estimate conditions will be valid for 60 days. After 60 days price and feasibility can change.</div>
            <div>* All prices are in USD.</div>

          </div>
        </div> -->
        <div class="button">
          <!-- <button @click="dialogVisible=true;sendQuotationEMail()">Send me the quotation by email</button> -->
        </div>
        <div class="button">
          <button @click="NextRequest()">Next Request</button>
        </div>

      </div>
    </div>
    <el-dialog title="" :visible.sync="dialogVisible" width="30%">
      <span>An email has been sent to your email box</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="NextRequest()">Next Request</el-button>
        <el-button type="primary" @click="dialogVisible = false;$router.push('/?source=rfq')">Home page</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getQuotationDetail, advertisementFlow, sendQuotationEMail } from "@/api/api";
export default {
  data() {
    return {
      quanttableData: [],
      qualtableData: [],
      dialogVisible: false,
      width: "",
      totalNumber: "",
      subTotalNumber: "",
      quantheight: "",
      projectname: "",
      discount: "",
      id: ""
      // specialDiscountShow:false
    };
  },
  created() {
    this.getQuotationList();
    this.iscookies();
    this.advertisementFlow(); // 在组件创建时加载Google代码
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://www.googletagmanager.com/gtag/js?id=AW-11335422054";
    document.head.appendChild(script);
    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        dataLayer.push(arguments);
      }
      gtag("js", new Date());
      gtag("config", "AW-11335422054");
    };
    // this.getheight();
  },
  methods: {
    sendQuotationEMail() {
      sendQuotationEMail({
        id: this.id,
        quotation: JSON.parse(localStorage.getItem("quotation"))
      }).then(res => {});
    },
    handleScroll() {
      //计算滚动条位置
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      //计算绑定div位置
      var offsetTop = document.querySelector(".el-table__header-wrapper").offsetTop;
      //进行比较设置位置fixed
      this.whether = scrollTop > offsetTop;
    },

    // getheight() {
    //   this.quantheight = this.$refs.quant.offsetHeight;
    //   if (this.quantheight > 500) {
    //     this.quantheight = 500;
    //   }
    //   console.log(this.quantheight);
    // },
    tableRowClassName({ row, rowIndex }) {
      if (row.rowName == "Total" || row.rowName == "Discount" || row.rowName == "Rebate Discount" || row.rowName == "New Relationship Discount" || row.rowName == "Total After Discount" || row.marketName == "Total") {
        return "success-row";
      }
      return "";
    },
    addClass({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 0) {
        //此判断为前两列
        return "addBorder";
      }
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (row.rowName == "Total" || row.rowName == "Discount" || row.rowName == "Total After Discount") {
        //  if(columnIndex==1){
        //   return[2,2]
        //  }
      }
    },
    advertisementFlow() {
      // 如果没有source
      if (this.$route.query.source == undefined) {
        // console.log(1);
        // 就把source拼接
        advertisementFlow({
          path: "rfq",
          source: "",
          information: "报价页"
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
            // console.log(source);
          }
        });
        // 如果有source
      } else {
        advertisementFlow({
          path: "rfq",
          source: this.$route.query.source,
          information: "报价页"
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
            // console.log(source);
          }
        });
      }
    },
    // 检测是否登录过，然后跳转
    iscookies() {
      // 如果登录过,看看过期没有，过期了要删除
      if (localStorage.getItem("logincookies")) {
        var val = localStorage.getItem("logincookies");
        var dataobj = JSON.parse(val);

        var newTime = new Date().getTime();
        if (newTime - dataobj.time > 21600000) {
          localStorage.removeItem("logincookies");
        }
      }
      if (!localStorage.getItem("logincookies")) {
        this.$router.push({ name: "equote", query: { source: "nologin" } });
      }
    },
    // 清空
    // removeRedisValue() {
    //   removeRedisValue({
    //     client: this.$route.query.client
    //   }).then(res => {
    //     console.log(res);
    //     var loginclient = JSON.parse(localStorage.getItem("login"));
    //     this.$router.push({ name: "Table", query: { client: loginclient, source: "morequote" } });
    //   });
    // },
    NextRequest() {
      var loginclient = JSON.parse(localStorage.getItem("login"));
      this.$router.push({ name: "Table", query: { client: loginclient, source: "morequote" } });
      this.dialogVisible = false;
    },
    // 获取rfq列表
    getQuotationList() {
      var rfqid = this.$route.query.id;
      getQuotationDetail({
        rfqId: rfqid
      }).then(res => {
        if (res.code == 10000) {
          this.projectname = JSON.parse(localStorage.getItem("projectname"));
          this.discount = JSON.parse(localStorage.getItem("discount"));
          this.id = res.data.id;
          this.quanttableData = res.data.quantitativeList;
          this.qualtableData = res.data.qualitativeList;
          this.subTotalNumber = res.data.qualitativeList.subTotalNumber;
          this.totalNumber = res.data.qualitativeList.totalNumber;
          // this.qualtableData.forEach((item,index)=>{
          //   console.log(item[index]);
          // if(item.list.cpi >= 1000){
          //     item.list.cpi=item.list.cpi.toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
          //   }
          //   if(item.list.subTotal >= 1000){
          //     item.list.subTotal=item.list.subTotal.toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
          //   }
          // })

          this.quanttableData.forEach(item => {
            if (item.cpiIncentive) {
              item.cpiIncentive = item.cpiIncentive.toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
              item.cpiIncentive = "$" + item.cpiIncentive;
            }

            if (Number(item.subTotal)) {
              item.subTotal = item.subTotal.toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
              item.subTotal = "$" + item.subTotal;
            }
            if (item.subTotalDiscount) {
              item.subTotalDiscount = item.subTotalDiscount.toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
              item.subTotalDiscount = "$" + item.subTotalDiscount;
            }
            if (item.cpiRecruitment) {
              item.cpiRecruitment = item.cpiRecruitment.toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
              item.cpiRecruitment = "$" + item.cpiRecruitment;
            }
            if (item.cpiTotal) {
              item.cpiTotal = item.cpiTotal.toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
              item.cpiTotal = "$" + item.cpiTotal;
            }
            // if(item.specialDiscount==null){
            //   this.specialDiscountShow=true
            // }
          });
          // if (this.qualtableData.headers.length <= 2) {
          //   this.width = false;
          // } else {
          //   this.width = "200";
          // }
          // this.qualtableData =[];
          // if(this.qualtableData.rows)
          // this.qualtableData.rows.forEach(item => {
          //   // console.log(item);
          //   // item.map(ite => {

          //   //   console.log(ite);
          //   // });
          //   for (var k in item) {
          //     // console.log(item[k]);
          //     if (item[k] == null) {
          //       item[k] = { cpi: "/", unit: "/", subTotal: "/" };
          //     }
          //   }
          // });
          // console.log(this.quanttableData);
        }
      });
    },

    // 只有一列合计
    getSummaries(param) {
      // console.log(param);
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        //这步是为了让最后一行出现 合计 这一行，并且最后一行第一列出现 合计 二字。合计的字可以在这里更改
        if (index === 0) {
          //判断是第一列
          sums[index] = "Total";
          return;
        }
        // 吧每个格子里面都变成数字，会返回数字或者nan
        const values = data.map(item => Number(item[column.property]));
        // console.log(column.property);
        // 不是nan的
        if (!values.every(value => isNaN(value)) && column.property == "subTotal") {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = "$" + sums[index];
        } else {
          sums[index] = "";
        }
      });
      return sums;
    }
    // qualgetSummaries(param) {
    //   const { columns, data } = param;
    //   // console.log(param);
    //   const sums = [];
    //   columns.forEach((column, index) => {
    //     //这步是为了让最后一行出现 合计 这一行，并且最后一行第一列出现 合计 二字。合计的字可以在这里更改
    //     if (index === 0) {
    //       //判断是第一列
    //       sums[index] = "Total";
    //       return;
    //     }
    //     // const values = data.map(item => console.log(item));
    //     // console.log(values);
    //     var values = [];
    //     data.forEach(item => {
    //       // console.log(item);
    //       for (var k in item) {
    //         // console.log(item[k]);
    //         values.push(item[k]);
    //         // console.log(values);
    //       }
    //     });
    //     // console.log(values);
    //     const value = values.map(item => Number(item.subTotal));
    //     // console.log(column.property);
    //   });
    //   return sums;
    // }
  }
};
</script>
<style lang="scss" scoped>
// .el-table{
// position: relative;
// }
// /deep/.el-table__header-wrapper{
// position: fixed;
// top: 300px;
// z-index: 999;
// }
* {
  word-break: break-word !important;
}
.rfqtitle {
  font-weight: 700;
  font-size: 40px;
  text-align: center;
  color: #0087d7;
}
/deep/.cell {
  word-break: break-word !important;
}
.wrong {
  font-size: 20px;
  font-weight: 700;
  color: red;
  margin: 20px 0;
}
/deep/.el-table .success-row {
  background: #f0f9eb;
}
/deep/.addBorder {
  width: 300px !important;
  text-align: left !important;
}
.qualAttention {
  margin-top: 30px;
  margin-bottom: 30px;
}
/deep/.el-table::before {
  border: none;
}

/deep/.is-center {
  border: 1px solid rgb(238, 229, 229);
}
.rfq {
  margin-top: 30px;
  margin-bottom: 100px;
  .label {
    font-size: 20px;
    border: 1px solid #67c23a;
    display: inline-block;
    padding: 8px 15px;
    border-radius: 8px;
    background-color: #f0f9eb;
    color: #67c23a;
  }
}
.button {
  text-align: center;
  button {
    margin-top: 30px;
    border: none;
    border-radius: 10px;
    padding: 8px 15px;
    background-color: #409eff;
    color: #fff;
    font-size: 20px;
    width: 400px;
    box-shadow: 1px 1px 1px #ccc;
  }
}
.left {
  text-align: left;
  display: flex;
  justify-content: space-between;
}
/deep/.el-table {
  margin-top: 15px;
}
.marginTop30 {
  margin-top: 0.3rem;
}
.fontBold {
  font-weight: bold;
}
.contentInfo {
  background: url("https://retailplatform.oss-cn-hangzhou.aliyuncs.com/holdenWebH5/contact_bg.jpg") no-repeat center top;
  background-size: 100% 100%;
  width: 100%;
  padding: 40px 0 75px;
  .contact {
    padding: 40px 50px;
    width: 90%;
    margin: 0 auto;
    background: #fff;
    .holden {
      font-size: 50px;
      font-weight: 700;
      color: #0070c0;
    }
    .introduce {
      color: #cc3300;
      font-size: 18px;
    }
  }
}
@media screen and (max-width: 576px) {
  .rfq {
    .label {
      font-size: 50px;
      padding: 10px 20px;
    }
  }
  .btn {
    button {
      font-size: 43px;
      width: 20%;
    }
  }
  .checkyes {
    font-size: 60px;
  }
  .type {
    font-size: 70px;
  }
  .check {
    width: 100px;
    height: 100px;
  }
  .contentInfo {
    .contact {
      width: 90%;
      .holden {
        font-size: 80px;
      }
      .introduce {
        font-size: 30px;
      }
    }
  }
  /deep/.el-table {
    font-size: 45px;
    .cell {
      height: 70px;
      line-height: 70px;
    }
    .is-leaf {
      height: 120px;
    }
  }
}
</style>
